<!-- <div id="openai_chat_model" class="chat_mk_bg ">

  <div class="show_sidebar_button" [ngClass]="{'sidepanel-btn-hidden' : !isFullWidth}" title="Sidebar Show"
    (click)="showSidePanel()">
    <mat-icon>double_arrow</mat-icon>
  </div>

  <div id="chat_main" class="chat_main_content chat_main_content_width" [ngClass]="{ 'full-width': isFullWidth }">
    <div id="chat_side_panel" class="chat_side_bar_panel chat_side_bar_panel_show">
      <div class="chat_sidebar_top">
        <div class="new_chat_button" (click)="startNewChat()">
          <mat-icon>add</mat-icon>
          <h3>New Chat</h3>
        </div>
        <div class="close_sidebar_button" title="Sidebar Close" (click)="closeSidePanel()">
          <mat-icon>keyboard_double_arrow_left</mat-icon>
        </div>
      </div>
      <div class="chat_sidebar_content">
        <div class="sidebar_content" *ngFor="let search of savedSearches; ">
          <h3 class="group_text" *ngIf="search?.data?.length > 0">{{search?.groupText}}</h3>
          <app-saved-chat [data]="search?.data" [selectedChatId]="selectedChatId" (onClickChat)="onClickChat($event)">
          </app-saved-chat>
        </div>


        <div *ngFor="let message of chatHistory" class="sidebar_content" (click)="selectHistoryItem(message)">
          <h3 class="group_text">{{ message.question }}</h3>
        </div>


      </div>
      <div class="chat_sidebar_bottom">
        <div class="chat_profile_img_wrapper">
          <ngx-avatar size="50" [src]="userProfile?.picture ? userProfile?.picture : ''" [name]="userProfile?.fullName"
            [textSizeRatio]="2" [round]="true" [initialsSize]="2"></ngx-avatar>
        </div>
        <div class="chat_profile_user">
          <p>{{'okaccr' | titlecase}}</p>
        </div>
      </div>
    </div>
    <app-new-chat *ngIf="isNewChat && selectedChatId === 0" [isFullWidth]="isFullWidth"
      [draggingWidth]="draggingWidth"></app-new-chat>
    <div id="scroll_area_container" style="overflow-y: auto; height: 100%;" *ngIf="!isNewChat && selectedChatId > 0">
      <app-save-chat-content [data]="selectedChatData" [isNewSearch]="isNewSearch" [newSearchData]="newSearchData">
      </app-save-chat-content>
    </div>
    <div id="scroll_button" class="scroll_to_end_button_wrapper">
      <mat-icon>arrow_circle_down</mat-icon>
    </div>

  </div>
  <div class="" [ngClass]="{'openai_chat_search-w-full': isFullWidth, 'openai_chat_search' : !isFullWidth}">
    <div>
      <button class="stop-respone-button" (click)="stopGeneratingResponse()" *ngIf="isRequestInProgress"
        mat-raised-button color="warn">Stop Generating Response</button>
    </div>
    <div class="search_wrapper"
      [ngClass]="{'search_wrapper-w-full': isFullWidth || draggingWidth, 'search_wrapper' : !isFullWidth}">
      <div class="search_area_wrapper">
        <textarea placeholder="Send a message" rows="1" id="chat_search_textarea" [formControl]="searchCtrl"
          (keyup.enter)="searchNewQuery()">
            </textarea>
      </div>
      <img src="../../../assets/images/aggrid-spinner.gif" width="30px" height="30px" alt="...loading"
        *ngIf="isRequestInProgress">
      <button [class.speaking]="isSpeaking" class="speaker-button" mat-icon-button (click)="startSpeechRecognition()">
        <mat-icon *ngIf="!isSpeaking">mic</mat-icon>
        <div *ngIf="isSpeaking" class="wave-dots">
          <div class="dot"></div>
          <div class="dot"></div>
          <div class="dot"></div>
          <div class="dot"></div>
        </div>
      </button>
      <button class="chat-send-button" mat-icon-button (click)="searchNewQuery()" *ngIf="!isRequestInProgress">
        <mat-icon id="chat_search_icon" style="color: darkcyan;">send</mat-icon>
      </button>
    </div>
  </div>
</div> -->

<div style="position: relative; width: 100%; height: 107%;">
  <iframe #iframeElement width="100%" height="100%" frameborder="0" style="position: absolute; top: 0; left: 0;">
  </iframe>

  <!-- Fake overlay div to hide part of iframe -->
  <div style="position: absolute; bottom: 0; left: 0; width: 100%; height: 50px; background-color: white; z-index: 10;">
  </div>
</div>


<!-- <iframe #streamlitFrame src="https://app-app-7vaicxa5dudznfqslwrmrk.streamlit.app?embed=true&embed_options=light_theme&hide_footer=true&hide_streamlit_footer=true" width="100%" height="100%" frameborder="0"></iframe> -->